"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantStatusDetailsReceiptToJSON = exports.ApplicantStatusDetailsReceiptFromJSONTyped = exports.ApplicantStatusDetailsReceiptFromJSON = void 0;
const runtime_1 = require("../runtime");
function ApplicantStatusDetailsReceiptFromJSON(json) {
    return ApplicantStatusDetailsReceiptFromJSONTyped(json, false);
}
exports.ApplicantStatusDetailsReceiptFromJSON = ApplicantStatusDetailsReceiptFromJSON;
function ApplicantStatusDetailsReceiptFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cardLastDigits': json['cardLastDigits'],
        'chargeDate': (new Date(json['chargeDate'])),
        'chargeAuthNumber': json['chargeAuthNumber'],
        'amountPaid': json['amountPaid'],
        'cardType': !runtime_1.exists(json, 'cardType') ? undefined : json['cardType'],
    };
}
exports.ApplicantStatusDetailsReceiptFromJSONTyped = ApplicantStatusDetailsReceiptFromJSONTyped;
function ApplicantStatusDetailsReceiptToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cardLastDigits': value.cardLastDigits,
        'chargeDate': (value.chargeDate.toISOString().substr(0, 10)),
        'chargeAuthNumber': value.chargeAuthNumber,
        'amountPaid': value.amountPaid,
        'cardType': value.cardType,
    };
}
exports.ApplicantStatusDetailsReceiptToJSON = ApplicantStatusDetailsReceiptToJSON;
//# sourceMappingURL=ApplicantStatusDetailsReceipt.js.map